import { WSTable, WSTableItem } from "@wingspanhq/fe-component-library";
import { useMemo } from "react";

import { PayrollRunSummary } from "../../types";

import { getColumns } from "./columns";

type Props = {
  items: PayrollRunSummary[];
  loading?: boolean;
  onDownload?: () => void;
  onRowOpen?: (id: string) => void;
};

export const TablePayrolls: React.FC<Props> = props => {
  const tableData = useMemo<WSTableItem<PayrollRunSummary>[]>(
    () => props.items.map(item => ({ id: item.id, data: item })),
    [props.items]
  );
  const columns = useMemo(() => getColumns(), []);

  return (
    <WSTable<PayrollRunSummary>
      columns={columns}
      headerAction={
        props.onDownload
          ? { icon: "download", onClick: props.onDownload }
          : undefined
      }
      loading={props.loading}
      rowMenuActions={item => [
        {
          icon: "file",
          label: "View details",
          onClick: () => props.onRowOpen?.(item.id)
        },
        {
          icon: "download",
          label: "Download summary",
          onClick: () => props.onDownload?.()
        }
      ]}
      tableData={tableData}
      onRowClick={item => props.onRowOpen?.(item.id)}
    />
  );
};
